// extracted by mini-css-extract-plugin
export default {"link":"NavToLink_link__SwW5r","light":"NavToLink_light__dN3uM","dark":"NavToLink_dark__xKTFA"};